package com.exura.features.legacyplans.domain.model

import kotlinx.serialization.Serializable

@Serializable
data class Answer(
    val answer: String,
    val positive: Boolean,
)
